import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from "@angular/router";
import {Observable} from "rxjs";
import {AutomaticSharePointUserCreationMode, GroupStorage, SettingsService} from "@coso-replicator/core";
import {map} from "rxjs/operators";

@Injectable()
export class AutomaticSharepointUserCreationGuard implements CanActivate {
  constructor(private settingsService: SettingsService, private router: Router) {}
  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const instanceId = _route.paramMap.get("instance-id");
    return this.settingsService.get(instanceId).pipe(
      map((data) => {
        const automaticSharePointUserCreation = data.automaticSharePointUserCreation;
        const groupStorage = data.groupStorage;
        return groupStorage === GroupStorage.SharePoint && automaticSharePointUserCreation !== AutomaticSharePointUserCreationMode.Disabled;
      })
    )
  }
}
